import {request, serviceUrl} from "@/utils/request";

//根据消防主机设备id查询所有楼层信息
export function getTierInfoByDeviceId(deviceId,floor) {
  return request({
    url: serviceUrl.deviceService + '/atn/structure/list',
    params: {
      deviceId,floor
    }
  })
}

// 获取消防主机树形结构接口
export function getlistAtnStrureTree() {
  return request({
    url: serviceUrl.deviceService + '/atn/structure/listAtnStrureTree'
  })
}
// 保存区域背景图和区域坐标信息
export function saveAreaInfo(areaInfo) {
  return request({
    method: 'POST',
    url: serviceUrl.deviceService + '/atn/structure/save',
    data: areaInfo
  })
}
